export default "__VITE_ASSET__241f81bd__"